<template lang="pug">
.avatarComponent(:style="avatarStyles")
  .inner(:style="innerStyles")
    .image(
      v-if="url",
      :style="imageStyles"
    )
    .placeholder(v-else)
      ui-svg-icon(
        name="user"
      )
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: null
    },
    borderRadius: {
      type: Number,
      default: null
    }
  },
  computed: {
    avatarStyles () {
      const styles = {}
      if (this.size) {
        styles.width = `${this.size}px`
        styles.height = `${this.size}px`
      }
      return styles
    },
    innerStyles () {
      return {
        width: this.size > 120 && this.url ? '95%' : '100%',
        height: this.size > 120 && this.url ? '95%' : '100%',
        borderRadius: this.borderRadius === null ? '99em' : `${this.borderRadius}px`
      }
    },
    imageStyles () {
      return {
        backgroundImage: `url('${this.url}')`
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.avatarComponent
  display: grid
  width: 100%
  height: 100%

  > .inner
    margin: auto
    border: 0.5*$u solid $cWhite
    background-color: $cWhite
    margin: auto
    overflow: hidden
    display: grid

    > .image
      background: no-repeat center
      background-size: cover

    > .placeholder
      margin: auto
      color: #314190
      width: 90%
      height: 90%
      margin: auto auto 0
</style>
